import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import type { LaneProps } from './Timeline';
import { sectionToneClass } from './sectionToneClass';
import { spanBox } from './timelineGeometry';
import styles from './SectionsLane.module.scss';

/**
 * The sections of the song map (design Timeline, c6), in the colour of their kind. A click selects
 * the section (the "Section" zoom, "For <section>" in the bank) and opens its recut box.
 */
const SectionsLaneComponent: React.FC<LaneProps> = ({ view }) => {
  const { songMap, sectionIndex, setSectionIndex, openRecut, readOnly } = useMusicVideoEditor();
  return (
    <div className={clsx(styles.lane, styles.hSections)}>
      {songMap.sections.map((section) => {
        const box = spanBox(section.startSec, section.endSec, view);
        if (box === null) {
          return null;
        }
        return (
          <button
            key={section.index}
            type="button"
            className={clsx(
              styles.section,
              sectionToneClass(section.kind),
              section.index === sectionIndex && styles.sectionOn
            )}
            style={{ left: `${box.left}%`, width: `calc(${box.width}% - 2px)` }}
            aria-pressed={section.index === sectionIndex}
            onClick={() => {
              setSectionIndex(section.index);
              if (!readOnly) {
                openRecut(section.index);
              }
            }}
          >
            {section.label}
            {section.mood !== null && <small>{section.mood}</small>}
          </button>
        );
      })}
    </div>
  );
};

export const SectionsLane = TypedMemo(SectionsLaneComponent);
